import { Header } from "@/components/shared/header";
import { PageContainer } from "@/components/shared/page-container";
import { TaskForm } from "@/components/tasks/task-form";
import { ChevronLeft } from "lucide-react";
import { Link, createFileRoute } from "@tanstack/react-router";

function NewTaskPage() {
  return (
    <PageContainer>
      <Header
        title="새 태스크"
        left={
          <Link to="/tasks" className="p-2 -ml-2">
            <ChevronLeft className="size-6" />
          </Link>
        }
      />

      <div className="bg-card rounded-xl p-6">
        <TaskForm mode="create" />
      </div>
    </PageContainer>
  );
}

export const Route = createFileRoute("/_content/tasks/new")({
  component: NewTaskPage,
});
